;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { stringify } from 'querystring';
import axiosInstance from '../utils/axios';
import { logSentryError } from '../utils/logSentry';

export async function getColleagues(officeId?: string) {
  try {
    const { data } = await axiosInstance(`/colleagues?${stringify({ includeUnpublished: false, office: officeId })}`);
    // TODO: add sorting in Synergie Start
    const priorityIds = ['67e42321322a4c04b66c8d61', '67e4233fe6eb98f2d44cbe16', '6705477b3b9eade20568e2b0'];

    const sortedData = data.sort((a, b) => {
      const aPriority = priorityIds.indexOf(a.id);
      const bPriority = priorityIds.indexOf(b.id);
      return (aPriority === -1 ? Infinity : aPriority) - (bPriority === -1 ? Infinity : bPriority);
    });
    return sortedData;
  } catch (error) {
    logSentryError(error);
    return [];
  }
}

export async function getJobCoaches() {
  try {
    const { data } = await axiosInstance(`/colleagues?${stringify({ showOnFirstJobPage: true })}`);
    return data.filter((c) => c.showOnFirstJobPage === true);
  } catch (error) {
    logSentryError(error);
    return [];
  }
}

export async function getColleagueByName(name: string) {
  try {
    const { data } = await axiosInstance(`/colleagues?${stringify({ name })}`);
    const [colleague] = data;
    return colleague;
  } catch (error) {
    logSentryError(error);
    return null;
  }
}
